var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: { data: _vm.list, border: "", "highlight-current-row": "" },
      on: {
        "selection-change": _vm.selectionChange,
        "sort-change": _vm.tableSortChange
      }
    },
    [
      _c("div", { attrs: { slot: "empty" }, slot: "empty" }, [
        _c("div", { staticStyle: { height: "50px" } }, [
          _vm._v(_vm._s(_vm.tableEmptyPlaceholder || "没有符合条件的数据"))
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("可尝试点击上方的 "),
          _c("b", [_vm._v("重置")]),
          _vm._v(" 按钮清空搜索条件, 或点击左侧视图名称, 切换工单视图")
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("向 "),
          _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
            _vm._v("管理员")
          ]),
          _vm._v(" 寻求帮助")
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.viewColumns, function(e) {
        return _c("ViewTicketTableColumn", {
          key: e,
          attrs: { prop: e },
          on: { "after-close-ticket": _vm.afterCloseTicket }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed4a9fac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed4a9fac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/ViewTicketTable.vue
// module id = 846
// module chunks = 75